import { SET_SELECTED_QUANTITY } from '../actions/constants';

const initialState = {
    selectedQuantity: 1
};

const reducers = (state = initialState, action) => {
    switch (action.type) {
        case SET_SELECTED_QUANTITY: {
            return { selectedQuantity: action.payload };
        }

        default:
            return state;
    }
};

export default reducers;
